<template>
  <div class="my-order" ref="container">
    <div class="header bg-color-red" style="height:100%">
      <div class="picTxt acea-row row-between-wrapper">
        <div class="text">
          <div class="name">线下订单信息</div>
          <div>
            累计订单：{{ order_count || 0 }} 总消费：￥{{ sum_price || 0 }}
          </div>
        </div>
        <div class="pictrue"><img src="@assets/images/orderTime.png" /></div>
      </div>
    </div>
    <div class="list">
      <div class="item" v-for="order in orderList" :key="order.id">
        <div class="title acea-row row-between-wrapper">
          <div class="acea-row row-middle">
            {{ order.KDRQ }}
          </div>
          <div class="font-color-red">已完成</div>
        </div>
        <div>
          <div
            class="item-info acea-row row-between row-top"
            v-for="item in order.shop"
          >
            <div class="pictrue">
              <img :src="item.image" />
            </div>
            <div class="text acea-row row-between">
              <div class="name line2">
                {{ item.store_name }}
              </div>
              <div class="money">
                <div>￥{{ order.SJ }}</div>
                <div>x{{ order.SL }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="totalPrice">
          共{{ order.shop.length || 0 }}件商品，总金额
          <span class="money font-color-red">￥{{ order.JSHJ }}</span>
        </div>
      </div>
    </div>
    <div class="noCart" v-if="orderList.length === 0 && page > 1">
      <div class="pictrue"><img src="@assets/images/noOrder.png" /></div>
    </div>
    <Loading :loaded="loaded" :loading="loading"></Loading>
    <Payment
      v-model="pay"
      :types="payType"
      @checked="toPay"
      :balance="userInfo.now_money"
    ></Payment>
  </div>
</template>
<script>
import { getOrderData, getOrderList, getOfflinelist } from "@api/order";
import {
  cancelOrderHandle,
  payOrderHandle,
  takeOrderHandle
} from "@libs/order";
import Loading from "@components/Loading";
import Payment from "@components/Payment";
import { mapGetters } from "vuex";
import { isWeixin } from "@utils";

const STATUS = [
  "待付款",
  "待发货",
  "待收货",
  "待评价",
  "已完成",
  "",
  "",
  "",
  "",
  "待付款"
];

const NAME = "MyOrder";

export default {
  name: NAME,
  data() {
    const { uid = 0 } = this.$route.query;
    return {
      uid: uid,
      offlinePayStatus: 2,
      order_count: "",
      sum_price: "",
      type: parseInt(this.$route.params.type) || 0,
      page: 1,
      limit: 20,
      loaded: false,
      loading: false,
      orderList: "",
      pay: false,
      payType: ["yue", "weixin"],
      from: isWeixin() ? "weixin" : "weixinh5"
    };
  },
  components: {
    Loading,
    Payment
  },
  computed: mapGetters(["userInfo"]),
  watch: {
    $route(n) {
      // if (n.name === NAME) {
      // 	const type = parseInt(this.$route.params.type) || 0;
      // 	if (this.type !== type) {
      // 		this.changeType(type);
      // 	}
      // 	this.getOrderData();
      // }
    }
  },
  methods: {
    orderlist: function() {
      getOfflinelist(this.uid).then(res => {
        this.sum_price = res.data.sum;
        this.order_count = res.data.count;
        this.orderList = res.data.newdata;
      });
    }
  },
  mounted() {
    this.orderlist();
  }
};
</script>

<style scoped>
.noCart {
  margin-top: 0.17rem;
  padding-top: 0.1rem;
}

.noCart .pictrue {
  width: 4rem;
  height: 3rem;
  margin: 0.7rem auto 0.5rem auto;
}

.noCart .pictrue img {
  width: 100%;
  height: 100%;
}
</style>
